import React, { useState, useRef } from "react";
import { Button } from "semantic-ui-react";
import BCModal from "../../ui/BCModal";
import { ModalSizesType } from "../../interfaces/Global";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { ModalContentType } from "./LmsFormGenerator";
import { appendIdToPath } from "../../../helpers/GlobalHelper";
import { FeatureFlags } from "../../constants/LocalServerConstants";

interface ILmsTableActionModalButtonProps {
  content?: string
  isDisabled?: boolean
  useLmsTableInstance: any
  modalContent?: ModalContentType
  modalSize?: ModalSizesType
  className?: string
  handleButtonClick?: (args?: any[]) => any,
  loading?: boolean
  icon?: string
  index?: number
  isIframeModal?: boolean
  iframeHeight?: number
  path?: string
}

const LmsTableActionModalButton = (
  {
    content = "",
    isDisabled = false,
    handleButtonClick = undefined as any,
    loading = false,
    icon = GlobalConstants.Icons.CARET_UP,
    modalContent,
    modalSize = "large",
    useLmsTableInstance = undefined as any,
    index = 0,
    isIframeModal = false,
    iframeHeight = 800,
    path = "",
  }: ILmsTableActionModalButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const iframeModalRef = useRef(null);
  const handleClick = () => {
    if (modalContent || isIframeModal) {
      setIsModalOpen(true);
    }
    if (handleButtonClick) {
      handleButtonClick(useLmsTableInstance);
    }
  };

  const parsedPath = path ? `${window.location.origin}${appendIdToPath({ path })}` : "";

  const handleIframeLoad = () => {
    const iframeItem = iframeModalRef.current as any;
    if (iframeItem) {
      if (FeatureFlags.IS_DEBUG) {
        console.log(iframeItem?.contentWindow);
      }

      iframeItem?.contentWindow?.sessionStorage?.setItem("iframeTitle", parsedPath); // TODO: Updated with needed functionality
    }
  };

  return <>
    <Button
      key={`button-group-action-child-field${index}`}
      onClick={handleClick}
      content={content}
      icon={icon}
      disabled={isDisabled}
      loading={loading}
      compact
    />
    {modalContent && isModalOpen && <BCModal
      isModalOpen
      size={modalSize}
      closeIcon
      onClose={() => setIsModalOpen(false)}
      isLoading={isModalLoading}
      content={typeof modalContent === "function" ? modalContent(setIsModalOpen, { ...useLmsTableInstance, setIsModalLoading }) : null}
    />}
    {isIframeModal && isModalOpen && parsedPath && <BCModal
      isModalOpen
      size={modalSize}
      closeIcon
      onClose={() => setIsModalOpen(false)}
      isLoading={isModalLoading}
      content={<iframe ref={iframeModalRef} src={parsedPath} width="100%" height={iframeHeight} style={{border: "none"}} title="Iframe Test" onLoad={handleIframeLoad} />}
    />}
  </>;
};

export default LmsTableActionModalButton;